import React, { useEffect, useState } from 'react';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import moment from 'moment';

/**
 * 
 * @param {{
 *  comment: import('./Comments').Comment,
 *  deleteComment: Function,
 *  isInEditMode: boolean,
 *  toggleEditMode: Function,
 *  canEditOrDelete: boolean,
 * }} param0 
 * @returns 
 */
export default function Comment({ comment: _comment, deleteComment, isInEditMode, toggleEditMode, canEditOrDelete }) {
    const [comment, setComment] = useState(_comment);

    useEffect(() => {
        setComment(_comment);
    }, [_comment]);

    const handleToggleEditMode = () => {
        toggleEditMode(comment);
    };

    return (
        <div className={`comment ${isInEditMode ? 'isInEditMode' : ''}`}>
            <div className='comment-control'>
                <div className='control-info'>
                    <span className='email'>{comment.addedBy && comment.addedBy.email}</span>
                    <span className='date'>{moment(comment.addedAt).format('DD.MM.YYYY hh:mm:ss')}</span>
                </div>
                {
                    canEditOrDelete ?
                    <div className='control-buttons'>
                        <EditIcon 
                            color={isInEditMode ? '#00BCD4' : '#EAEAEA'}
                            style={{ cursor: 'pointer' }}
                            onClick={handleToggleEditMode}
                        />
                        <DeleteIcon 
                            color='#EAEAEA' 
                            style={{ cursor: 'pointer' }}
                            onClick={() => deleteComment(comment._id)}
                        />
                    </div>
                    : null
                }
            </div>
            <div className='comment-text'>
                {comment.text}
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/comments/Comment.jsx